export const SUPPORT_EMAIL = 'support@releva.ai';
